import { call, put, takeEvery } from 'typed-redux-saga'
import { fmsUnitsApi, FmsNS, fmsSlice, errorHandler } from 'Modules'

function* getAll(action: FmsNS.GetAll) {
	try {
		yield* put(fmsSlice.actions.setAll([]))
		const res = yield* call(fmsUnitsApi.getAll, action.payload.params)
		yield* put(fmsSlice.actions.setAll(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* fmsUnitSaga() {
	yield* takeEvery(fmsSlice.actions.getAll.type, getAll)
}
